var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C2CCD2;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#0B77BD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.1,188.4c28.8-4.4,57.6-3.1,82.8,7.5l3-6.8c-40.7-13.1-92-12.4-130.2,8.5l10.9-25.3 c-47.9,13-80.2,40-112.6,67.9c23.7-55.9,75.1-101.8,133.2-118.5l-2.9,9.3c51-16.6,106.9-19.8,152.1-12.3L274.8,105l26,6.6l16.7-25 l6.6,30.8l25.6,8.3c0,0-18.6,7.8-17.7,8.2c96.7,39.8,65.7,172.2-26.2,172.9c-46.5,0.4-82.6-41.7-81.1-85.6 C201,205.6,177.3,198.1,149.1,188.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4,133.9c5.4-2.3,15.3-6.7,15.3-6.7l0.7-0.3l-0.8-0.2c0,0-16-5.3-19.4-6.4c-0.5-3.6-3-21-3-21l-0.1-0.8l-5.9,9.5 c0,0-3.3,5.4-5.2,8.3c-3.8-1-20.3-5.2-20.3-5.2l-0.8-0.3l0.5,0.7c0,0,6.7,8.7,10.8,14c-16.6-3.6-35.8-5.7-57.8-5.7 c-7.2,0-14.8,0.2-22.5,0.7c-29.9,1.7-59.4,7.3-87.7,17.5l3.2-9.6l-0.6,0.2C84.6,142.4,36.2,184,14.7,224.9l0.5,0.4 c30.2-28.4,71.2-51.1,107.9-59.3l-9.6,22.4l0.7-0.4c17.1-8.3,39.5-11.9,62.2-11.9c23.2,0,46.5,3.8,64.6,10.4l-6.9,15.1 c-16.5-7.6-40.2-12.6-60-12.6c-3.5,0-6.9,0.2-10.1,0.5l-0.1,0.6c23.4,6.6,47.5,14.1,66.6,29.4c-0.1,1.6-0.2,3.2-0.2,4.9 c0,40.4,34.9,76.9,75.8,76.9c0.3,0,0.5,0,0.8,0c45.1-0.5,78.5-41.9,78.5-85C385.4,184.7,367.2,151.9,322.4,133.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.7,207.9c-16.7,0-33.4-6.1-50-12.2c-4.4,9.3-6.7,19.1-6.7,29c0,5.3,0.6,10.6,1.9,16c1.4,0,2.7,0,4.1,0 c32.3,0,66.6-9,94.3-25.4c-3.2-6-7.2-11.5-11.2-16.8C319.3,205.3,308.5,207.9,297.7,207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.9,247.1h-1.1c10.1,26.1,33.3,43.5,61.6,43.9c9-22.2,19.1-46.6,42.1-58c-1.2-4-2.6-7.9-4.2-11.7 C314.6,238.4,280.1,247.1,245.9,247.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.8,165.1c-10-3.8-16.5-5.1-17.1-5.2c-2.8,0.4-6.7,0.8-9.7,1.4c17.1,6.8,29.7,15.1,42.4,29.2 c6.5-5.2,12.2-11,16.2-18.1c-11.6-11.3-33.5-25.2-88.1-29.4c23,5.5,44.2,12.8,56.5,21.6L315.8,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.8,157.5c3.3-0.1,7.1-0.1,10.9-0.1c38.7,0,98.6,4.5,121.8,32.1l-0.4,0.5c-8-4.4-24.1-11.9-34.1-11.8 c-0.3,0-0.6,0-0.9,0c-3.4,3.8-6.5,8-9.2,12.3c15.5,5.8,31.2,11.4,46.8,11.4c9.8,0,19.5-2.2,29.1-8.1 c-26.9-29.3-72.4-42.1-115.3-42.1C194.4,151.6,177.7,153.6,162.8,157.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.2,212.3c7.5-5.1,14-10.4,19.8-17.3c-3.7-7.1-10.1-15-14.7-19c-4.2,7.6-9.7,13.7-16.4,19.2 C338.9,200.4,343.1,206.5,346.2,212.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313,290.6c13.6-1.6,26.2-6.3,36.7-15.3c1.6-6.1,2.3-12.2,2.3-18.5c0-6-0.6-11.9-1.7-17.8 C329.7,248.9,321.1,270.6,313,290.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358,260.9c0,2-0.1,4.1-0.1,6.2c8-10.8,12.2-20.2,14.7-34c-5.9,0.5-11.6,1.5-17.1,3.3 C357.2,244.5,358,252.6,358,260.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349,218c1.8,4.1,3.4,8.3,4.8,12.6c6.4-2.1,12.6-3.1,19.3-3.5c0-0.5,0-0.9,0-1.4c0-8.8-1.3-15.7-4.1-24.1 C362.8,207.8,356.3,213.1,349,218"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,227c-6.7,0.4-12.8,1.5-19.3,3.5c-1.4-4.2-3-8.5-4.8-12.6c7.3-4.9,13.7-10.2,19.9-16.5 c2.8,8.5,4.1,15.3,4.1,24.1C373.1,226.1,373.1,226.5,373.1,227"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,227c-6.7,0.4-12.8,1.5-19.3,3.5c-1.4-4.2-3-8.5-4.8-12.6c7.3-4.9,13.7-10.2,19.9-16.5 c2.8,8.5,4.1,15.3,4.1,24.1C373.1,226.1,373.1,226.5,373.1,227"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.4,176c4.5,4,11,11.9,14.7,19c-5.9,6.9-12.3,12.2-19.8,17.3c-3.1-5.8-7.3-11.8-11.2-17.1 C341.7,189.7,347.1,183.6,351.4,176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.4,176c4.5,4,11,11.9,14.7,19c-5.9,6.9-12.3,12.2-19.8,17.3c-3.1-5.8-7.3-11.8-11.2-17.1 C341.7,189.7,347.1,183.6,351.4,176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,142.8c54.6,4.2,76.4,18.1,88.1,29.4c-3.9,7.2-9.7,12.9-16.2,18.1c-12.6-14.2-25.3-22.3-42.4-29.2 c3-0.6,6.9-1,9.7-1.4c0.6,0.1,7,1.3,17.1,5.2l0.3-0.5C303.8,155.8,282.5,148.4,259.5,142.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,142.8c54.6,4.2,76.4,18.1,88.1,29.4c-3.9,7.2-9.7,12.9-16.2,18.1c-12.6-14.2-25.3-22.3-42.4-29.2 c3-0.6,6.9-1,9.7-1.4c0.6,0.1,7,1.3,17.1,5.2l0.3-0.5C303.8,155.8,282.5,148.4,259.5,142.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.1,240.8c-1.4,0-2.7,0-4.1,0c-1.3-5.4-1.9-10.7-1.9-16c0-9.9,2.2-19.7,6.7-29c16.8,6.2,33.4,12.2,50,12.2 c10.8,0,21.6-2.6,32.5-9.4c4.1,5.4,8.1,10.9,11.2,16.8C313.7,231.8,279.4,240.8,247.1,240.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.1,240.8c-1.4,0-2.7,0-4.1,0c-1.3-5.4-1.9-10.7-1.9-16c0-9.9,2.2-19.7,6.7-29c16.8,6.2,33.4,12.2,50,12.2 c10.8,0,21.6-2.6,32.5-9.4c4.1,5.4,8.1,10.9,11.2,16.8C313.7,231.8,279.4,240.8,247.1,240.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.4,290.8c-28.3-0.4-51.5-17.7-61.6-43.9h1.1c34.2,0,68.6-8.7,98.2-26c1.6,3.8,3.1,7.8,4.2,11.7 C325.5,244.2,315.5,268.6,306.4,290.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.4,290.8c-28.3-0.4-51.5-17.7-61.6-43.9h1.1c34.2,0,68.6-8.7,98.2-26c1.6,3.8,3.1,7.8,4.2,11.7 C325.5,244.2,315.5,268.6,306.4,290.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.8,267.1c0.1-2,0.1-4.1,0.1-6.2c0-8.2-0.8-16.4-2.6-24.5c5.5-1.8,11.3-2.8,17.1-3.3 C370.2,246.9,365.8,256.3,357.8,267.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.8,267.1c0.1-2,0.1-4.1,0.1-6.2c0-8.2-0.8-16.4-2.6-24.5c5.5-1.8,11.3-2.8,17.1-3.3 C370.2,246.9,365.8,256.3,357.8,267.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.7,193.7c-9.6,5.9-19.3,8.1-29.1,8.1c-15.6,0-31.2-5.7-46.8-11.4c2.7-4.3,5.8-8.6,9.2-12.3 c0.3,0,0.6,0,0.9,0c10,0,26.1,7.4,34.1,11.8l0.4-0.5c-23.2-27.5-83-32.1-121.8-32.1c-3.8,0-7.5,0-10.9,0.1 c14.9-3.7,31.5-5.8,48.6-5.8C254.3,151.6,299.8,164.5,326.7,193.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.7,193.7c-9.6,5.9-19.3,8.1-29.1,8.1c-15.6,0-31.2-5.7-46.8-11.4c2.7-4.3,5.8-8.6,9.2-12.3 c0.3,0,0.6,0,0.9,0c10,0,26.1,7.4,34.1,11.8l0.4-0.5c-23.2-27.5-83-32.1-121.8-32.1c-3.8,0-7.5,0-10.9,0.1 c14.9-3.7,31.5-5.8,48.6-5.8C254.3,151.6,299.8,164.5,326.7,193.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.7,275.4c-10.5,8.9-23,13.5-36.7,15.3c8.2-20,16.8-41.7,37.3-51.6c1.1,5.9,1.7,11.8,1.7,17.8 C352,263.1,351.3,269.3,349.7,275.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.7,275.4c-10.5,8.9-23,13.5-36.7,15.3c8.2-20,16.8-41.7,37.3-51.6c1.1,5.9,1.7,11.8,1.7,17.8 C352,263.1,351.3,269.3,349.7,275.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "295.8,139.8 307.6,135.6 316.6,145.9 315.6,132.5 327,127.5 314.6,123.4 312.7,110.1 305.9,120.9  293.2,117.7 301.6,128.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "232.5,149.4 240.8,145.4 247.6,151.4 246.3,142.3 254.2,137.8 245.1,136.2 243.2,127.3 239,135.3  229.9,134.4 236.2,141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.9,167.6 145.2,165 149.8,168.9 148.9,162.9 154.1,159.9 148.2,158.9 146.9,153 144.1,158.4  138.1,157.8 142.3,162.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M345,249.6v-1.1l-7.7,12.8l2.2-11.3l-0.5-0.3c-11.2,13.5-15.5,23.4-19,35.4l-0.2,0.6l0.6-0.2 c12.5-4.3,19.1-9.4,21.7-11.5h0.1v-0.1c1.9-4,2.7-12.3,2.7-22.3C345,250.9,345,250.2,345,249.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.4,219.9c-12.2,2.5-26.5,3.9-39.6,3.9c-1.9,0-3.9,0-5.8-0.1l28.1-8.3l-0.1-0.6c-18.5-0.9-32.9-1.2-51-9.7 l-0.3-0.1l-0.1,0.2c-2.7,4.9-4.2,11.6-4.2,18.5c0,3.9,0.5,7.8,1.5,11.4l0.1,0.2h0.2c0,0,0.6,0,1.8,0c8.1,0,41.3-0.9,69.6-15 L319.4,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M325.6,242.7c-14.2,10.5-24.9,19-45.7,22.9c19.3-10,32.4-17,44.5-29.3l-0.4-0.5c-21.6,12.5-49.7,18-69.7,18.7 h-0.5l0.3,0.5c16.4,25.9,37,28.2,43.8,28.2l0,0c1.4,0,2.2-0.1,2.2-0.1h0.1l0.1-0.1c8.8-13.8,14.4-27.2,25.7-39.8L325.6,242.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.2,193.3c-1.8,2-3.6,3.7-5.5,5.5c-2-4.3-4.3-8.5-7.2-12.5c1.4-1.7,2.8-3.5,4.1-5.4 C357.1,184.7,360.2,189.2,362.2,193.3 M369.7,220.8c-2.2,0.3-4.2,0.6-6.2,1c-0.4-3.2-1.1-6.5-1.9-9.6c2.1-1.8,4.2-3.6,6.4-5.7 C369.1,211.2,369.6,215.5,369.7,220.8 M362.6,250.1l-0.1-1.1c0.9-4.5,1.4-9,1.6-13.4c1.2-0.3,2.4-0.6,3.6-0.8 C366.4,240.3,364.8,245.3,362.6,250.1 M311.1,156.5c-1-0.5-2.1-1-3.1-1.5c16.7,5,28,11.4,34.3,16.3c-1,1.4-2,2.8-3.1,4.1 C331.4,167.4,322,160.8,311.1,156.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrl);
export default __webpack_public_path__ + "static/media/ORL.057ddbef2fcf85fdfaeb42766f0a0ee6.svg";
export { ForwardRef as ReactComponent };